import clsx from "clsx";
import { KTSVG } from "src/_metronic/helpers";
import { QuickLinks } from "../layout/QuickLinks";

const toolbarButtonMarginClass = "ms-1 ms-lg-3";
const toolbarButtonHeightClass = "w-30px h-30px w-md-40px h-md-40px";
const toolbarButtonIconSizeClass = "svg-icon-1";

const QuickLinksMenu = () => {
    return (
        <div className={clsx("d-flex align-items-center", toolbarButtonMarginClass)}>
            {/* begin::Menu wrapper */}
            <div
                className={clsx(
                    "btn btn-icon btn-active-light-primary btn-custom",
                    toolbarButtonHeightClass
                )}
                data-kt-menu-trigger="click"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="right-end"
                data-kt-menu-flip="bottom"
            >
                <KTSVG
                    path="/media/icons/duotune/general/gen025.svg"
                    className={toolbarButtonIconSizeClass}
                />
            </div>
            <QuickLinks />

            {/* end::Menu wrapper */}
        </div>
    );
};

export default QuickLinksMenu;
